<script>
import { mapActions, mapGetters } from 'vuex';

import request from '@/services/request';
import Catalogue from '@/services/catalogue';
import Pagination from 'vue-pagination-2';

import ModalFormComponentContracts from '@/components/contracts_new/ModaFormComponent.vue';
import ModalRulesBillingComponent from '@/components/rules_billing/ModalRulesBillingComponent.vue';

export default {
    name: "rules-billing-table",
    components: {
        Pagination,
        ModalFormComponentContracts,
        ModalRulesBillingComponent
    },
    data() {
        return {
            editForm: false,
            load: false,
            catalogue: new Catalogue(),
            page: 1,
            years: Array.from({ length: 20 }, (v, i) => 2020 + i),
            search: {
                search: '',
                building_id: '',
                company_id: '',
                status: 1,
                finish: '',
                user_id: '',
                month: '',
                year: '',
                payment_period_id: [1, 2, 3, 4, 6, 7, 8, 9]
            },
        }
    },
    methods: {
        rules(contract) {
            Event.$emit('event-show-addCreateBillExternalRuless', contract);
        },            
        showAddendum(idContract) {
            this.editForm = false;
            Event.$emit('event-show-showContractID', idContract);
        },        
        addendum(buy) {
            this.editForm = true;
            let addendum = 1;
            Event.$emit('event-show-renewContracts', buy, addendum);
        },
      
        showNewContracts(contract = false, edit = true) {
            this.editForm = edit;
            Event.$emit('event-show-addNewContracts', contract);
        },                   
        async list(page = 1) {
            this.load = true;
            let service = request;
            let search = this.search;
            search.search = this.name;
            let _endpoint = '/rules_billing';
            try {
                let { data } = await service.list(_endpoint, page, search)
                if (data) {
                    console.log(data);
                    this.buys = data;
                    this.load = false;
                }
            } catch (error) {
                console.log(error);
                this.load = false;
            }
        },          
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    mounted() {
        this.list();
        this.catalogue.get_buildings();
        this.catalogue.get_companies_all();
        this.catalogue.get_users_profile(7);
        // this.catalogue.get_count_contracts_departments();
    },
    created() {
        Event.$on("event-load-contracts", () => {
            this.list();
        });
    },
    watch: {
        "search": {
            handler: function () {
                this.list();
            },
            deep: true
        },
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}

</script>
<template>
    <div class="col-12">
        <ModalFormComponentContracts :prop_edit="editForm" />
        <ModalRulesBillingComponent />
        <div class="card card-outline card-info">
            <div class="card-header">
                <h3 class="card-title">Lista de Contratos</h3>              
            </div>
            <div class="card-body">
                <div class="row">

                    <div class="col-md-6">
                        <label>Propiedad :</label>
                        <select class="form-control" v-model="search.building_id" @change="list()">
                            <option value="">Todas</option>
                            <option :value="building.id" v-for="(building, index) in catalogue.buildings" :key="index">
                                {{ building.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label>Empresa :</label>
                        <select class="form-control" v-model="search.company_id" @change="list()">
                            <option value="">Todas</option>
                            <option :value="company.id" v-for="(company, index) in catalogue.companies_all"
                                :key="index">{{ company.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label>Estatus :</label>
                        <select class="form-control" v-model="search.finish" @change="list()">
                            <option value="">Todas</option>
                            <!-- <option value="1">Por terminar</option> -->
                            <!-- <option value="2">Por incrementar</option> -->
                            <option value="3">Falta porcentaje </option>
                            <option value="4">Vencido sin finalizar</option>
                            <option value="5">Falta firma</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label>Cliente :</label>
                        <select class="form-control" v-model="search.user_id" @change="list()">
                            <option value="">Todas</option>
                            <option :value="user.id" v-for="(user, user_index) in catalogue.users_profile"
                                :key="user_index">{{ user.name }} {{ user.last_name }}</option>
                        </select>
                    </div>
                    <div class="col-md-3" v-if="search.finish">
                        <label>Fecha :</label>
                        <select class="form-control" v-model="search.month" @change="list()">
                            <option value="">Todas</option>
                            <option value="1">Enero</option>
                            <option value="2">Febrero</option>
                            <option value="3">Marzo</option>
                            <option value="4">Abril</option>
                            <option value="5">Mayo</option>
                            <option value="6">Junio</option>
                            <option value="7">Julio</option>
                            <option value="8">Agosto</option>
                            <option value="9">Septiembre</option>
                            <option value="10">Octubre</option>
                            <option value="11">Noviembre</option>
                            <option value="12">Diciembre</option>
                        </select>
                    </div>
                    <div class="col-md-3" v-if="search.finish">
                        <label>Año :</label>
                        <select class="form-control" v-model="search.year" @change="list()">
                            <option value="">Todas</option>
                            <option v-for="year in years" :key="year" :value="year">{{ year }}</option>

                        </select>
                    </div>
                </div>
                <br>
                <div class="row">

                    <div class="col-md-12">
                        <ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" @click="search.status = 1" data-toggle="pill" role="tab"
                                    aria-selected="true">Activos</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" @click="search.status = 2" data-toggle="pill" role="tab"
                                    aria-selected="false">Terminados</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered text-center text-sm">
                        <thead>
                            <tr>
                                <th style="width: 50px;">ID</th>
                                <th style="width: 200px;">Datos del pago</th>
                                <th style="width: 100px;">Fecha</th>
                                <th style="width: 100px;">Monto</th>
                                <th style="width: 100px;">Servicios</th>
                                <th style="width: 100px;">Opciones</th>
                            </tr>
                        </thead>
                        <tbody v-if="load">
                            <tr>
                                <td align="center" colspan="7">
                                    <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                    <h5>Cargando</h5>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="buys.data && buys.data.length > 0">
                            <tr :class="buy.authorization_user_id ? 'bg-info' : ''" v-for="(buy, index) in buys.data"
                                :key="index">
                                <td>
                                    {{ buy.id }}
                                </td>
                                <td class="text-left">

                                    <strong>Propiedad:</strong>
                                    <span v-if="buy.building">
                                        {{ buy.building.name }}
                                    </span>
                                    <span v-else>Sin propiedad</span>
                                    <br>

                                    <strong>Usuario:</strong>
                                    <span v-if="buy.user">
                                        {{ buy.user.name }} {{ buy.user.last_name }}
                                    </span>
                                    <span v-else>Sin usuario</span>
                                    <br>

                                    <!-- Recurrencia -->
                                    <strong>Recurrencia:</strong>
                                    <span v-if="buy.payment_period"> {{ buy.payment_period.name
                                        }}</span>
                                    <span v-else>Sin Recurrencia</span>
                                    <br>

                                    <!-- Fecha de registro -->
                                    <strong>Fecha de registro:</strong>
                                    <span>
                                        {{ buy.created_at | toDateTime }}
                                    </span>
                                    <br>

                                    <!-- Renta unica -->
                                    <strong>Renta única:</strong>
                                    <span v-if="buy.unique_rent == 1">
                                        Si
                                    </span>
                                    <span v-else>
                                        No
                                    </span>
                                    <br>

                                    <!-- Addendum -->
                                    <strong v-if="buy.all_parent_ids.length >= 1">Addendum:</strong><br
                                        v-if="buy.all_parent_ids.length >= 1">
                                    <a class="badge p-1 badge-info ml-1" v-show="buy.all_parent_ids.length >= 1"
                                        style="cursor: pointer;"
                                        @click="showAddendum(parent)"
                                        v-for="(parent, index) in buy.all_parent_ids" :key="index">
                                        Contrato # {{ parent }}
                                    </a>
                                    <br v-if="buy.all_parent_ids.length >= 1">

                                    <!-- Administrador -->
                                    <div v-if="buy.user_admin.length > 0">
                                        <strong>Administrador:</strong><br>
                                        <p class="badge p-1 badge-info mb-0" v-for="(admin, index) in buy.user_admin"
                                            :key="index">
                                            {{ admin.user.name }} {{ admin.user.last_name }}
                                        </p>
                                    </div>

                                    <!-- Juridical -->
                                    <div v-if="buy.user_juridical.length > 0">
                                        <strong>Jurídico:</strong><br>
                                        <p class="badge p-1 badge-info mb-0"
                                            v-for="(auxiliar, index) in buy.user_juridical" :key="index">
                                            {{ auxiliar.user.name }} {{ auxiliar.user.last_name }}
                                        </p>
                                        <br>
                                    </div>

                                    <!-- Auxiliar -->
                                    <div v-if="buy.user_auxiliary.length > 0">
                                        <strong>Analista Contable:</strong><br>
                                        <p class="badge p-1 badge-info mb-0"
                                            v-for="(juridical, index) in buy.user_auxiliary" :key="index">
                                            {{ juridical.user.name }} {{ juridical.user.last_name }}
                                        </p>
                                        <br>
                                    </div>

                                    <!-- Indivisos -->
                                    <strong>Indivisos:</strong><br>
                                    <span class="badge p-1 badge-success ml-1"
                                        v-for="(department, index) in buy.departments" :key="index">
                                        Piso {{ department.level }} / {{ department.number }} <span
                                            v-if="department.date"> - {{ department.date | toDateTime }}</span>
                                    </span>
                                    <br>
                                       
                                </td>
                                <td>
                                    <span v-if="buy.start_date"> {{ buy.start_date | toDateTime }} </span>
                                    <br>-<br>
                                    <span v-if="buy.end_date"> {{ buy.end_date | toDateTime }} </span>
                                    <span v-else> Sin fecha fin </span>

                                </td>
                                <td class="text-center">
                                    <!-- Renta única -->
                                    <div v-if="buy.unique_rent == 1 && buy.unique_rent_data">
                                        <span class="badge p-1 badge-success">Renta</span><br>
                                        {{ buy.unique_rent_data.subtotal | toCurrency }}
                                    </div>
                                    <div v-else-if="buy.departments">
                                        <div v-for="(department, index) in buy.departments" :key="index">
                                            <span class="badge p-1 badge-success ml-1"> Renta / Piso {{ department.level
                                                }} / {{ department.number }}</span><br>
                                            {{ department.subtotal_rent | toCurrency }}
                                        </div>
                                    </div>

                                    <!-- Depósito único -->
                                    <div v-if="buy.unique_deposit == 1">
                                        <span class="badge p-1 badge-info">Depósito</span><br>
                                        {{ buy.deposit_amount | toCurrency }}
                                    </div>
                                    <div v-else-if="buy.departments">
                                        <div v-for="(department, index) in buy.departments" :key="index">
                                            <span class="badge p-1 badge-info ml-1">Depósito / Piso {{ department.level
                                                }} / {{ department.number }}</span><br>
                                            {{ department.deposit | toCurrency }}
                                        </div>
                                    </div>

                                </td>
                                <td class="text-center">
                                    <div v-if="buy.unique_services == 1">
                                        <div v-for="(service, index) in buy.unique_services_data" :key="index"
                                            v-show="service.include_rent == false && service.subtotal > 0">
                                            <span class="badge p-1 badge-success" v-if="service.service">{{
                                                service.service.name }}</span>
                                            <span class="badge p-1 badge-success" v-else>{{ service.service_name
                                                }}</span><br>
                                            {{ service.subtotal | toCurrency }}
                                        </div>
                                    </div>
                                    <div v-else-if="buy.departments">
                                        <div v-for="(department, index) in buy.departments" :key="index">
                                            <div v-for="(service, index_service) in department.services"
                                                :key="index_service"
                                                v-show="service.include_rent == false && service.subtotal > 0">
                                                <span class="badge p-1 badge-success">
                                                    <p class="mb-1">{{ service.name }}</p>
                                                    Piso {{ department.level }} / {{ department.number }}
                                                </span><br>
                                                {{ service.subtotal | toCurrency }}
                                            </div>
                                        </div>
                                    </div>
                                </td>

                                <td>

                                         
                                    <button @click="showNewContracts(buy, false)" type="button"
                                        class="btn btn-sm  m-1 btn-outline-secondary ">
                                        <i class="fa-solid fa-eye"></i> Ver
                                    </button>                         

                                    <button @click="rules(buy)" v-can="'edit_contracts'"
                                        class="btn btn-outline-primary m-1 btn-sm">
                                        <i class="fas fa-edit "> </i> Reglas de Facturación
                                    </button>
                                

                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td align="center" colspan="7">Sin resultados.</td>
                            </tr>
                        </tbody>

                    </table>
                    <pagination v-model="page" :records="buys.total" :per-page="buys.per_page" @paginate="list" />
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    color: #ffffff;
    background-color: #214d83;
    border-color: #dee2e6 #dee2e6 #fff;
}

.selected {
    color: #000;
    font-weight: bold;
    animation: blinkingText 4s infinite;
}

.text-purple {
    color: #322348;
}
</style>